import LineChartComponent from './line-chart';

export default LineChartComponent;
